import { useQuery } from "@tanstack/react-query";
import { apiClient } from "~/lib/client";

import { authService } from "../service/auth.service";
import { authKeys } from "./keys";
import { handleError } from "~/utils/response";
import { handleResponse } from "~/utils/response";
import { AuthUser } from "~/types/users";


export const useAuthUser = () => {

  return useQuery({
    queryKey: authKeys.me(),
    retry: false,
    queryFn: async () => {
      try {
        const response = await apiClient("/admin/users/me");

        const result = await handleResponse<AuthUser>(response);

        if (!result.success) {
          throw new Error(result.error || "Error fetching authenticated user");
        }
        return result.data;
      } catch (error) {
        handleError(error);
      }
    },
    enabled: authService.isAuthenticated(),
  });
};
